var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 8,
    fill: "#FCB320"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.6867 6.08879C15.4482 6.20102 15.1629 6.55176 14.8402 7.13631C14.714 7.37481 13.9237 8.96948 13.0866 10.6904C12.2495 12.4067 11.4825 13.9312 11.3843 14.0808C11.0944 14.5158 10.7577 14.6748 10.3742 14.5578C10.1404 14.4877 9.71952 14.0762 8.62055 12.8416C7.58706 11.6865 7.21762 11.4153 6.79206 11.5135C6.16542 11.6538 5.94562 12.1401 6.01109 13.2718C6.07189 14.3988 6.5863 19.7487 6.74062 20.8944C7.11474 23.6395 7.72735 24.8227 9.0882 25.4493C9.83643 25.7954 10.4678 25.9029 12.1653 25.9731C13.6524 26.0385 20.2556 26.0011 20.9337 25.9263C22.547 25.7439 23.3561 25.4025 24.0295 24.6029C24.6468 23.878 24.9928 22.8211 25.2594 20.8944C25.4137 19.7487 25.9281 14.3988 25.9889 13.2718C26.0544 12.1401 25.8346 11.6538 25.2079 11.5135C24.7824 11.4153 24.4129 11.6865 23.3794 12.8416C22.2805 14.0762 21.8596 14.4877 21.6258 14.5578C21.2423 14.6748 20.9056 14.5158 20.6157 14.0808C20.5175 13.9312 19.7552 12.4067 18.9181 10.6904C17.2486 7.27661 17.0241 6.83702 16.7155 6.4442C16.5004 6.17296 16.2245 5.99994 16 5.99994C15.9345 5.99994 15.7942 6.04202 15.6867 6.08879ZM19.3203 21.3668C19.5588 21.5071 19.6944 21.7315 19.6944 21.9934C19.6944 22.2553 19.5588 22.4798 19.3203 22.6201C19.1613 22.7183 19.1005 22.7183 16 22.7183C12.8995 22.7183 12.8387 22.7183 12.6797 22.6201C12.0905 22.2787 12.2167 21.4509 12.8808 21.2919C12.9603 21.2686 14.41 21.2545 16.0935 21.2592C19.0911 21.2686 19.1613 21.2686 19.3203 21.3668Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProIcon);
export default __webpack_public_path__ + "static/media/proIcon.6a3582cf0b8ae8356dc66c079322e1f6.svg";
export { ForwardRef as ReactComponent };